module.exports = __webpack_public_path__ + "img/1420.51f35910.gif";